import * as React from 'react';
import { cn } from '../../helpers';
import smoothScroll from '../../utilities/smooth-scroll';

export default class SubNav extends React.Component<SubNavProps, SubNavState> {
    public setTimeoutInstance: number | null = null;

    public navBar: React.RefObject<HTMLDivElement>;

    public navBarInner: React.RefObject<HTMLDivElement>;

    public constructor(props: SubNavProps) {
        super(props);

        this.state = {
            sticky: false,
            hash: window.location.hash
        };
        this.navBar = React.createRef();
        this.navBarInner = React.createRef();
    }

    public componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, false);
        if (window.location.hash.length) {
            this.setTimeoutInstance = window.setTimeout(() => smoothScroll(window.location.hash), 1000);
        }
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, false);
        if (this.setTimeoutInstance) window.clearTimeout(this.setTimeoutInstance);
    }

    public handleClick = (event: React.SyntheticEvent<HTMLAnchorElement>, href: string) => {
        event.currentTarget.blur();
        smoothScroll(href, event);
    };

    public handleScroll = () => {

        if (this.navBarInner.current && this.navBar.current && this.navBar.current.parentElement) {
            const subNavSectionRect = this.navBar.current.parentElement.getBoundingClientRect();
            setTimeout(() => {
                const sticky = subNavSectionRect.top < 2;
                this.setState({ sticky, hash: window.location.hash });
                const activeSubNav = document.getElementsByClassName('sub-nav__item--active');
                // if (activeSubNav.length > 0 && sticky) activeSubNav[0].scrollIntoView();
                if (activeSubNav.length > 0 && sticky) {
                    activeSubNav[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
            }, 30);
        }
    };

    public render() {
        const { sticky, hash } = this.state;
        const { navItems } = this.props;
        return (
            navItems.length > 0 && (
                <div ref={this.navBar} className="sub-nav">
                    <div
                        ref={this.navBarInner}
                        className={cn('sub-nav', {
                            'sub-nav__item-justify-content ': navItems.length > 2,
                            'sub-nav--sticky': sticky,
                            'border-bottom': !sticky
                        })}
                    >
                        {navItems.map(item => (
                            <a
                                key={item.href}
                                className={cn('sub-nav__item', { 'sub-nav__item--active': item.href === hash })}
                                href={item.href}
                                onClick={e => this.handleClick(e, item.href)}
                                title=""
                                data-testid={item.href}
                            >
                                {item.label}
                            </a>
                        ))}
                    </div>
                </div>
            )
        );
    }
}
